// extracted by mini-css-extract-plugin
module.exports = {"form-wrapper":"clientCreateView_form-wrapper__3ZP3n"};